'use client';

import NumberField from '@koda/koda-components/molecules/NumberField';
import { getLatestArrearsHalfAndYear } from '@koda/koda-utils/date';
import { useTranslations } from 'next-intl';
import { ReactElement } from 'react';
import { LicenseTypes } from '../../../types/licenses';
import { useLicenseBusiness } from '../hooks/useLicenseBusiness';
import { createHandballDefaults, HANDBALL_CONTENT_PATH, handballSchema } from './handball.Schema';

export default function HandballComponent(): ReactElement {
  const licenseCode = LicenseTypes.Handball;
  const { values, setField, getError, costCalculated, showErrors } = useLicenseBusiness(licenseCode, {
    schema: handballSchema,
    defaults: createHandballDefaults,
  });
  const t = useTranslations(HANDBALL_CONTENT_PATH);

  const paymentPeriod = () => {
    const { halfLabel, year } = getLatestArrearsHalfAndYear();
    return `${t(`spectators.${halfLabel}`)} ${year}`;
  };

  return (
    <>
      <NumberField
        label={t('spectators.label', { period: paymentPeriod() })}
        name="spectators"
        required
        formatThousands
        disabled={costCalculated}
        value={values.spectators}
        error={values.spectators || showErrors ? getError('spectators') : undefined}
        data-error-field={showErrors && !!getError('spectators') ? 'true' : undefined}
        validated={!!values.spectators && !getError('spectators')}
        onChange={e => setField('spectators', parseInt(e.target.value))}
        min={1}
        sign="positive-only"
        styleVariant="border"
      />
    </>
  );
}
